const Glide = window.Glide;
import { centerControlsOnCardContainer, disableIfGlideFit, setButtonsVisibility } from "../../../Scripts/glideControls.js";
const sliders = document.querySelectorAll(".block__eventListingWidget .glide");
const glideControls = document.querySelectorAll(".block__eventListingWidget .block__glideControls");
let glides = [];
const slideStorage = {};
const eventListing = ( () => { 
  function setUpCarousel() {
  const options = {
      perView: 3,
      peek: { before: 0, after: 142 },
      bound: true,
      gap: 16,
      breakpoints: {
        489: {
          perView: 1,
          rewind:false,
          peek: { before: 0, after: 74 },
          gap: 16,
        },
        649: {
          perView: 1,
          rewind:false,
          peek: { before: 0, after: 160 },
          gap: 16,
        },
        767: {
          perView: 1,
          rewind:false,
          peek: { before: 0, after: 210 },
          gap: 16,
        },
        1023: {
          perView: 2,
          rewind:false,
          peek: { before: 0, after: 156 },
          gap: 16,
        },
        1365: {
          perView: 3,
          rewind:false,
          gap: 16,
          peek: { before: 0, after: 150 },
        },
      },
    };
  sliders.forEach((slider) => {
    let glide = new Glide(slider, options);
    glide.on("move.after",  () => {
      let firstButton = glide.selector.querySelector(".button__glide.button__prev");
      let lastButton = glide.selector.querySelector(".button__glide.button__next");
      let numOfSlides = glide.selector.querySelectorAll(".glide__slide").length;
      setButtonsVisibility(glide, firstButton, lastButton, numOfSlides);
    });
      glide.on("build.after", () => {
          let imageHolders = glide.selector.querySelectorAll(".block__contentContainer");
          centerControlsOnCardContainer(imageHolders, glideControls);
    });
    glides.push(glide.mount());
  });

    for(let i = 0; i < glides.length; i++) {
      disableIfGlideFit(glides[i]);
    }
  }
    if (sliders) {
        sliders.forEach((slider) => {
            let widgetGuid = $(slider).closest('.block__eventListingWidget').data('guid');
            slideStorage[widgetGuid] = $(slider).find('.glide__slide').clone();

            window.addEventListener("resize", () => {
                for (let i = 0; i < glides.length; i++) {
                    disableIfGlideFit(glides[i]);
                }
                sliders.forEach((slider) => {
                    let imageHolders = slider.querySelectorAll(".block__contentContainer");
                    centerControlsOnCardContainer(imageHolders, glideControls);
                });
            });

        });
    }

  setUpCarousel();
  return { setUpCarousel: setUpCarousel }
})();

document.addEventListener('DOMContentLoaded', () => {
    applyVerticleLineSeperators();
    adjustCardHeights();
});


function adjustCardHeights() {
    const cardElements = document.querySelectorAll('.block__contentContainer');
    if (cardElements.length === 0) return;

    let tallestCardHeight = 0;

    // Reset heights to auto before measuring
    cardElements.forEach(card => {
        card.style.height = 'auto';
    });

    // Find the tallest card
    cardElements.forEach(card => {
        const height = card.offsetHeight;
        if (height > tallestCardHeight) {
            tallestCardHeight = height;
        }
    });

    // Set all cards to the tallest height
    cardElements.forEach(card => {
        card.style.height = `${tallestCardHeight}px`;
    });
}


function applyVerticleLineSeperators() {
    let cardElements = document.querySelectorAll('.block__partialBorder');
    if (cardElements) {
        let cardElementsArray = Array.from(cardElements);
        let cardElementsCount = cardElementsArray.length;
        if(cardElementsCount > 0)
            cardElementsArray[cardElementsCount - 1].classList.remove('block__partialBorder');
    }
}

$('.block__eventListingWidget .type-filter').on('change', function () {
    let $widget = $(this).closest('.block__eventListingWidget');
    let widgetGuid = $widget.data('guid');
    let $filter = $('.type-filter', $widget);
    let $closedDisplay = $('.button__filters', $filter);
    //let $slides = $('.glide__slide', $widget);
    let $slides = slideStorage[widgetGuid];

    // collected selected types (will be a 1-element array as long as 
    // we use radios instead of checkboxes)
    let selectedTypes = [];
    $('input:checked', $filter).each(function () {
        selectedTypes.push(this.value);
        // set text of closed dropdown - will need to change if we allow 
        // selection of more than one type
        let labelText = $(this).next().text();
        $closedDisplay.text(labelText);
    });

    // clear slideHolder
    let $slideHolder = $('.glide__slides', $widget);
    $slideHolder.html('');

    if (selectedTypes.length == 1 && selectedTypes[0] == 'all') {
        // Show All Types
        $slideHolder.append($slides);
        $closedDisplay.text('All Types');
    }
    else {
        // filter to selected types
        $slides.each(function () {
            let slideTypes = this.dataset.eventTypes.split('|');
            let showMe = false;
            for (let selType of selectedTypes) {
                if (slideTypes.indexOf(selType) !== -1) {
                    showMe = true;
                    break;
                }
            }
            if (showMe)
                $slideHolder.append(this);
        });
    }

    for (let glide of glides) {
        glide.destroy();

        //disableIfGlideFit(glide);
        //centerControlsOnImage(imageHolder, glideControls);
    }
    glides = [];
    eventListing.setUpCarousel();
});

export {eventListing}